import React, { useState, useEffect } from 'react';
import axios from 'axios';
import bitcoinImage from '../assets/bitcoin.png';
import zcashImage from '../assets/zcash.png';
import BtcAth from './BtcAth';
import ZecAth from './ZecAth';


const Bitcoin = () => {
  const [price, setPrice] = useState(0);
  const [bitcoinData, setBitcoinData] = useState({ amount: '', percent: '', date: '' });
  const [pricez, setPricez] = useState(0);
  

  const getPrice = () => {
    axios
      .get('https://api.coinbase.com/v2/prices/BTC-USD/spot')
      .then((res) => {
        const newPrice = Number(res.data.data.amount);
        setPrice(newPrice);
        // Update the browser tab title with the Bitcoin price
        document.title = `BTC: $${newPrice.toLocaleString()} | WenDip?`;
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get('https://api.coinbase.com/v2/prices/ZEC-USD/spot')
      .then((res) => {
        const newPrice = Number(res.data.data.amount);
        setPricez(newPrice);
      })
      .catch((err) => {
        console.log(err);
        
      });
  };

  useEffect(() => {
    getPrice();
    const interval = setInterval(getPrice, 5000);
    return () => clearInterval(interval);
  }, []);

  // useEffect(() => {
  //   axios
  //     .get('https://raw.githubusercontent.com/c3nturi0n2013/data/master/btc.json')
  //     .then((res) => {
  //       setBitcoinData({
  //         amount: res.data.amount,
  //         percent: res.data.percent,
  //         date: res.data.date,
  //       });
  //     })
  //     .catch((err) => {
  //       console.log('Error fetching Bitcoin data:', err);
  //     });
  // }, []);

  return (
    <div className="container">
      <h1>
        Bitcoin = <span className="btc-price">${price.toLocaleString()}</span>
      </h1>
      <div className="rotating-bitcoin">
        <img src={bitcoinImage} alt="Bitcoin" />
      </div>
      <h2 className="norm">1 Satoshi (Sat) = ${(price / 100000000).toFixed(8)}</h2>
      <h4>100 million sats = 1 Bitcoin</h4>
      <h4>One US 🇺🇸 dollar can buy you {(1 / (price / 100000000)).toFixed(2)} sats</h4>
      
      <BtcAth />
      <h1>
        Zcash = <span className="zec-price">${pricez.toLocaleString()}</span>
      </h1>
      <div className="rotating-bitcoin">
        <img src={zcashImage} alt="Zcash"/>
      </div>
      <h2 className="norm">1 Zatoshi (Zat) = ${(pricez / 100000000).toFixed(8)}</h2>
      <h4>100 million zats = 1 Zcash</h4>
      <h4>One US 🇺🇸 dollar can buy you {(1 / (pricez / 100000000)).toFixed(2)} zats</h4>

      <ZecAth />
    </div>
  );
};

export default Bitcoin;